export default __webpack_public_path__ + "static/media/cal-pill.a532d562.jpg";